import useTranslation from 'next-translate/useTranslation';

/*
 * You have to pass the namespace with the token
 * Example:
 * const { t_error } = useErrorTranslation();
 * t_error('errors:error_occured')
 */
const useErrorTranslation = () => {
    const { t } = useTranslation();
    const t_error = (token, query_param = {}) => {
        return t(token, query_param, { fallback: 'errors:error_occured' });
    };

    return { t_error };
};

export default useErrorTranslation;
